import { useState } from "react";
import client from "./client";
import { usePoll } from "../hooks/usePoll";
import { useWeatherCoords } from "../hooks/useWeatherCoords";

const TTL_MS = 15 * 60 * 1000;
const cache = new Map(); // key -> { at, data }

export const fetchWeather = async (lat, lon) => (await client.get("/weather", { params: { lat, lon } })).data;
export const fetchPlace = async (lat, lon, lang) =>
  (await client.get("/weather/place", { params: { lat, lon, lang } })).data;

// الطقس يتبع موقع الجهاز الفعلي (GPS) لا الفرع ولا عنوان الإنترنت، ويُخزَّن 15 دقيقة لكل موقع.
export const useWeather = (branch, lang = "ar") => {
  const coords = useWeatherCoords(branch);
  const key = coords ? `${coords.lat.toFixed(3)},${coords.lon.toFixed(3)},${lang}` : null;
  const [data, setData] = useState(() => (key ? cache.get(key)?.data ?? null : null));

  const load = async () => {
    if (!key) return;
    const hit = cache.get(key);
    if (hit) setData(hit.data);
    if (hit && Date.now() - hit.at < TTL_MS) return;
    try {
      const [weather, place] = await Promise.all([
        fetchWeather(coords.lat, coords.lon),
        fetchPlace(coords.lat, coords.lon, lang).catch(() => null),
      ]);
      const value = { ...weather, place: place?.name || null, source: coords.source };
      cache.set(key, { at: Date.now(), data: value });
      setData(value);
    } catch {
      if (!cache.get(key)) setData(null);
    }
  };

  usePoll(load, TTL_MS, [key]);

  return data;
};
